<template>
    <article>
        <section>
            <h1>Super Mario Galaxy Map Renders</h1>
            <h3>2007</h3>

            <p>These pieces were done for
                <a href="https://www.amazon.com/Super-Mario-Galaxy-Prima-Official/dp/0761556435?ie=UTF8&*Version*=1&*entries*=0" target="_blank">
                    Prima's Official Strategy Guide for Super Mario Galaxy</a>.
            </p>

            <img src="../assets/page-mario-galaxy/mario-galaxy-render-1.png" alt="Mario Galaxy Map Render 1">
            <img src="../assets/page-mario-galaxy/mario-galaxy-render-2.png" alt="Mario Galaxy Map Render 2">
            <img src="../assets/page-mario-galaxy/mario-galaxy-render-3.png" alt="Mario Galaxy Map Render 3">
            <img src="../assets/page-mario-galaxy/mario-galaxy-render-9.png" alt="Mario Galaxy Map Render 9">
            <img src="../assets/page-mario-galaxy/mario-galaxy-render-8.png" alt="Mario Galaxy Map Render 8">
            <img src="../assets/page-mario-galaxy/mario-galaxy-render-4.png" alt="Mario Galaxy Map Render 4">
            <img src="../assets/page-mario-galaxy/mario-galaxy-render-5.png" alt="Mario Galaxy Map Render 5">
            <img src="../assets/page-mario-galaxy/mario-galaxy-render-6.png" alt="Mario Galaxy Map Render 6">
            <img src="../assets/page-mario-galaxy/mario-galaxy-render-7.png" alt="Mario Galaxy Map Render 7">
        </section>
    </article>
</template>

<script>
    export default {
        name: "GalaxyMaps"
    }
</script>